import { PostCardStack } from './post-card-stack';
import type { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { SessionsPostCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/post-cards-4x6/sessions-post-card-stack-background/sessions-post-card-stack-background.component';
import { SessionsPostCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/post-cards-4x6/sessions-post-card-stack-content/sessions-post-card-stack-content.component';

export class SessionsPostCardStack extends PostCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> | null {
    return SessionsPostCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return SessionsPostCardStackContentComponent;
  }
}
